import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FaChartLine, 
  FaTable, 
  FaClock,
  FaServer,
  FaExchangeAlt,
  FaWallet,
  FaBullseye,
  FaDatabase,
  FaUsers,
  FaShieldAlt,
  FaEllipsisH
} from 'react-icons/fa';
import '../styles/mobile/MobileFooter.css';
import { cacheManager } from '../hooks/GlobalCacheManager';

const mainNavigationItems = [
  { path: '/ftso-submissions', icon: FaTable, label: 'FTSO' },
  { path: '/fdc-submissions', icon: FaShieldAlt, label: 'FDC' },
  { path: '/nodes', icon: FaServer, label: 'NODES' },
  { path: '/validators', icon: FaUsers, label: 'VALIDATORS' }
];

const moreNavigationItems = [
  { path: '/indexers', icon: FaDatabase, label: 'Indexers' },
  { path: '/fast-updates', icon: FaClock, label: 'Fast Updates' }
];

function MobileFooter() {
  const location = useLocation();
  const [showMoreMenu, setShowMoreMenu] = useState(false);

  const toggleMoreMenu = () => {
    setShowMoreMenu(!showMoreMenu);
  };

  const closeMoreMenu = () => {
    setShowMoreMenu(false);
  };

  const isMoreItemActive = moreNavigationItems.some(item => item.path === location.pathname);

  return (
    <>
      {/* Overlay to close menu when clicking outside */}
      {showMoreMenu && (
        <div className="more-menu-overlay" onClick={closeMoreMenu} />
      )}
      
      {/* More submenu */}
      {showMoreMenu && (
        <div className="more-submenu">
          {moreNavigationItems.map(({ path, icon: Icon, label }) => (
            <Link 
              key={path}
              to={path}
              className={`more-nav-item ${location.pathname === path ? 'active' : ''}`}
              onClick={closeMoreMenu}
              onMouseEnter={() => cacheManager.prewarmForRoute(path)}
              onFocus={() => cacheManager.prewarmForRoute(path)}
              onTouchStart={() => cacheManager.prewarmForRoute(path)}
            >
              <Icon className="more-nav-icon" />
              <span className="more-nav-label">{label}</span>
            </Link>
          ))}
        </div>
      )}

      {/* Main navigation footer */}
      <nav className="mobile-footer">
        {mainNavigationItems.map(({ path, icon: Icon, label }) => (
          <Link 
            key={path}
            to={path}
            className={`nav-item ${location.pathname === path ? 'active' : ''}`}
            onClick={closeMoreMenu}
            onMouseEnter={() => cacheManager.prewarmForRoute(path)}
            onFocus={() => cacheManager.prewarmForRoute(path)}
            onTouchStart={() => cacheManager.prewarmForRoute(path)}
          >
            <Icon className="nav-icon" />
            <span className="nav-label">{label}</span>
          </Link>
        ))}
        
        {/* MORE button */}
        <button 
          className={`nav-item more-button ${isMoreItemActive ? 'active' : ''}`}
          onClick={toggleMoreMenu}
        >
          <FaEllipsisH className="nav-icon" />
          <span className="nav-label">MORE</span>
        </button>
      </nav>
    </>
  );
}

export default React.memo(MobileFooter);